import type { HelpTopic } from '../core/index.js'

/** The feedback module's help topics (docs/plans/in-app-help-plan.md). */
export const FEEDBACK_HELP_TOPICS: readonly HelpTopic[] = [
  {
    id: 'feedback.changes',
    title: 'Changes',
    seats: ['admin'],
    summary: 'Feedback accepted for development, written up as a requirement and carried through the root admin’s approvals to an accepted pull request.',
    sections: [
      {
        heading: 'How a change moves',
        points: [
          'Develop on an open feedback item starts a draft change linked to it.',
          'Any admin writes the requirement. Each Save is a new version.',
          'Submit sends the saved version to the root admin. It stays off while the requirement lacks something, or while a policy decision has no answer.',
          'The root approves that exact version by its content hash, or returns it to draft with a reason.',
          'The root runs the approved prompt, records the pull request that comes back and accepts it at the commit reviewed.',
        ],
      },
      {
        heading: 'Who does what',
        points: [
          'Every admin sees every change and can write a draft.',
          'Approving, recording the pull request, sending back, accepting, rejecting and cancelling are the root admin’s alone. Everyone else sees where a change waits on the root.',
          'Accepting completes the linked feedback. Rejecting or cancelling frees it to be developed again.',
        ],
      },
      {
        heading: 'Good to know',
        points: [
          'If someone else saved the change since you opened it, your save is refused. Reload and make your edit again.',
          'Merging and deploying stay manual.',
        ],
      },
    ],
    related: [],
  },
]
